export interface Airfield {
    id?: string;
    code?: string;
    icaoCode?: string;
    latitude: number;
    longitude: number;
    name: string;
    region: string;
    province: string;
    municipality: string;
    firstPhotoUrl?: string;
    isRegistred?: boolean;
    tenantId: string;
}

export const defaultAirfield: Airfield = {
    id: '',
    icaoCode: '',
    latitude: 0,
    longitude: 0,
    name: '',
    region: '',
    province: '',
    municipality: '',
    isRegistred: false,
    tenantId: '',
};